<div class="p-2">
  @if (rows.length) {
  <p class="static-text">
    {{ "DOCUMENTS_ON_MYCASE_STATI4" | globalTranslate }}
  </p>
  } @if (rows.length && isPartnerApp && !readTCC) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (rows.length && isPartnerApp && readTCC) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (rows.length) {
  <h1 class="section-header">
    {{ "DOCUMENTS_ON_MYCASE_STATI3" | globalTranslate }}
  </h1>
  } @if (!documentsLoading && !rows.length) {
  <h1 class="section-header">
    {{
      (partnerOrgDocSwitch
        ? "DOCUMENTS_ON_MYCASE_STATI2_ORG"
        : "DOCUMENTS_ON_MYCASE_STATI2"
      ) | globalTranslate
    }}
  </h1>
  }
  <hr />
  @if (rows.length && partnerOrgDocSwitch) {
  <p class="static-text">{{ "DOCUMENTS_ON_MYCASE_TEXT" | globalTranslate }}</p>
  } @if (!documentsLoading && !rows.length) {
  <p class="static-text">
    {{
      (partnerOrgDocSwitch
        ? "DOCUMENTS_ON_MYCASE_STATI5_ORG"
        : "DOCUMENTS_ON_MYCASE_STATI5"
      ) | globalTranslate
    }}
  </p>
  } @if (!documentsLoading && !rows.length && isPartnerApp && !readTCC) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (!documentsLoading && !rows.length && isPartnerApp && readTCC) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (rows.length) {
  <div class="d-none d-lg-block">
    <ngx-datatable
      class="bootstrap striped"
      #table
      [rows]="rows"
      [limit]="5"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
    >
      <ngx-datatable-column
        [name]="'Case or Appeal Numbers' | globalTranslate"
        prop="caseNum"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        [name]="'Document Type' | globalTranslate"
        prop="docType"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        [name]="'Who This Is For' | globalTranslate"
        prop="fullName"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        [name]="'Date of Upload' | globalTranslate"
        prop="uploadDt"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'Source' | globalTranslate" prop="source">
        <ng-template ngx-datatable-cell-template let-value="value">
          <span>{{ value | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  }

  <div class="d-lg-none nh-table-mobile">
    @if (rows.length) { @for (row of rows; track row) {
    <div class="table-row mb-3 pb-3">
      <div class="mobile-table-header">
        {{ columns[0].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.caseNum }}</div>
      <br />
      <div class="mobile-table-header">
        {{ columns[1].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.docType | globalTranslate }}</div>
      <br />
      <div class="mobile-table-header">
        {{ columns[2].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.fullName }}</div>
      <br />
      <div class="mobile-table-header">
        {{ columns[3].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.uploadDt }}</div>
      <br />
      <div class="mobile-table-header">
        {{ columns[4].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.source | globalTranslate }}</div>
      <br />
    </div>
    } }
    <!-- <p *ngIf="!rows.length" class="mb-5">No data to display</p> -->
  </div>
</div>